import {
  Box,
  Typography,
  TextField,
  FormControl,
  FormControlLabel,
  Checkbox,
  FormLabel,
  Paper,
  Grid,
  Chip,
} from "@mui/material";
import { Receipt } from "@mui/icons-material";
import { useFormContext, Controller } from "react-hook-form";
import { useState, useEffect } from "react";

export default function ERechnungenForm() {
  const { register, watch, setValue, control } = useFormContext();

  const [selectedFormate, setSelectedFormate] = useState([]);
  const [selectedSchutzmassnahmen, setSelectedSchutzmassnahmen] = useState([]);

  const formateOptions = [
    "PDF",
    "XML", 
    "EDIFACT",
    "E-Mail-Anhänge",
    "ZUGFeRD",
    "XRechnung"
  ];

  const schutzmassnahmenOptions = [
    "Verschlüsselung",
    "Zugriffskontrolle",
    "Backup-System",
    "Audit-Trail",
    "Digitale Signatur",
    "Virus-Scan"
  ];

  useEffect(() => {
    const initial = watch("erechnungen.formate");
    if (initial) setSelectedFormate(initial.split(", ").filter(Boolean));
  }, []);

  useEffect(() => {
    const initial = watch("erechnungen.schutzmassnahmen");
    if (initial) setSelectedSchutzmassnahmen(initial.split(", ").filter(Boolean));
  }, []);

  const toggleChip = (item, selectedItems, setSelectedItems, fieldName) => {
    let updated;
    if (selectedItems.includes(item)) {
      updated = selectedItems.filter((i) => i !== item);
    } else {
      updated = [...selectedItems, item];
    }
    setSelectedItems(updated);
    setValue(fieldName, updated.join(", "));
  };

  const Beschriftung = ({ children }) => (
    <Typography variant="subtitle2" gutterBottom>{children}</Typography>
  );

  return (
    <Box sx={{ maxWidth: 800, mx: "auto", p: 2 }}>
      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Receipt sx={{ fontSize: 40, color: "primary.main", mr: 2 }} />
                 <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>
                 Verfahren und Kontrollen für den Umgang mit E-Rechnungen             </Typography>
        </Box>
      </Paper>

      {/* Eingang und Identifikation */}
      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: "600" }}>
          Eingang und Identifikation elektronischer Rechnungen
        </Typography>
        
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Beschriftung>Wo werden eingehende E-Rechnungen empfangen und gespeichert?</Beschriftung>
            <Controller
              name="erechnungen.eingangsort"
              control={control}
              render={({ field }) => (
                <TextField 
                  {...field} 
                  label="Eingangsort für E-Rechnungen" 
                  fullWidth
                  placeholder="z.B. E-Mail-Postfach, Portal, DMS..."
                />
              )}
            />
          </Grid>
          
          <Grid item xs={12}>
            <Beschriftung>Welche Formate werden für E-Rechnungen akzeptiert?</Beschriftung>
            <Grid container spacing={1}>
              {formateOptions.map((item) => (
                <Grid item key={item}>
                  <Chip
                    label={item}
                    clickable
                    color={selectedFormate.includes(item) ? "primary" : "default"}
                    onClick={() =>
                      toggleChip(item, selectedFormate, setSelectedFormate, "erechnungen.formate")
                    }
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Beschriftung>Wie erfolgt die Identifikation und Prüfung von E-Rechnungen?</Beschriftung>
            <Controller
              name="erechnungen.identifikationsverfahren"
              control={control}
              render={({ field }) => (
                <TextField 
                  {...field} 
                  label="Identifikationsverfahren" 
                  multiline
                  rows={3}
                  fullWidth
                  placeholder="Beschreibung des Verfahrens zur Identifikation und Prüfung..."
                />
              )}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Aufbewahrung und Archivierung */}
      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: "600" }}>
          Aufbewahrung und Archivierung
        </Typography>
        
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Beschriftung>Wo werden E-Rechnungen archiviert?</Beschriftung>
            <Controller
              name="erechnungen.archivierungsort"
              control={control}
              render={({ field }) => (
                <TextField 
                  {...field} 
                  label="Archivierungsort" 
                  fullWidth
                  placeholder="z.B. DMS, ERP-System, Cloud..."
                />
              )}
            />
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Beschriftung>Wie erfolgt die Indexierung der E-Rechnungen?</Beschriftung>
            <Controller
              name="erechnungen.indexierung"
              control={control}
              render={({ field }) => (
                <TextField 
                  {...field} 
                  label="Indexierungssystem" 
                  fullWidth
                  placeholder="z.B. Rechnungsnummer, Datum, Lieferant..."
                />
              )}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Schutzmaßnahmen */}
      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: "600" }}>
          Schutzmaßnahmen
        </Typography>
        
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Beschriftung>Welche Schutzmaßnahmen werden für E-Rechnungen eingesetzt?</Beschriftung>
            <Grid container spacing={1}>
              {schutzmassnahmenOptions.map((item) => (
                <Grid item key={item}>
                  <Chip
                    label={item}
                    clickable
                    color={selectedSchutzmassnahmen.includes(item) ? "primary" : "default"}
                    onClick={() =>
                      toggleChip(item, selectedSchutzmassnahmen, setSelectedSchutzmassnahmen, "erechnungen.schutzmassnahmen")
                    }
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Beschriftung>Wie erfolgt die Zugriffskontrolle auf E-Rechnungen?</Beschriftung>
            <Controller
              name="erechnungen.zugriffskontrolle"
              control={control}
              render={({ field }) => (
                <TextField 
                  {...field} 
                  label="Zugriffskontrolle" 
                  multiline
                  rows={3}
                  fullWidth
                  placeholder="Beschreibung der Zugriffskontrolle..."
                />
              )}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Prüfungszugriff */}
      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: "600" }}>
          Prüfungszugriff
        </Typography>
        
        <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
          Der Prüfungszugriff beschreibt, wie einem Prüfer (z.B. vom Finanzamt) Zugang zu den E-Rechnungen gewährt wird. 
          Dies umfasst die technischen und organisatorischen Maßnahmen, die sicherstellen, dass ein Prüfer die E-Rechnungen 
          einsehen, durchsuchen und auswerten kann.
        </Typography>
        
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <FormControl component="fieldset" fullWidth>
              <FormLabel component="legend">Prüfungszugriff</FormLabel>
              <FormControlLabel
                control={<Checkbox {...register("erechnungen.volltextsuche")} />}
                label="Volltextsuche möglich"
              />
              <FormControlLabel
                control={<Checkbox {...register("erechnungen.maschinelle_auswertung")} />}
                label="Maschinelle Auswertung möglich"
              />
              <FormControlLabel
                control={<Checkbox {...register("erechnungen.bildschirm_einsicht")} />}
                label="Bildschirmeinsicht für Prüfer"
              />
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Beschriftung>Prüfungszugriff-Verfahren</Beschriftung>
            <Controller
              name="erechnungen.pruefungszugriff"
              control={control}
              render={({ field }) => (
                <TextField 
                  {...field} 
                  label="Prüfungszugriff-Verfahren" 
                  multiline
                  rows={3}
                  fullWidth
                  placeholder="Beschreibung des Prüfungszugriffs..."
                />
              )}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Zuständigkeiten */}
      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: "600" }}>
          Zuständigkeiten
        </Typography>
        
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Beschriftung>Wer ist verantwortlich für E-Rechnungen?</Beschriftung>
            <Controller
              name="erechnungen.verantwortlicher"
              control={control}
              render={({ field }) => (
                <TextField 
                  {...field} 
                  label="Verantwortlicher für E-Rechnungen" 
                  fullWidth
                  placeholder="Name und Position..."
                />
              )}
            />
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Beschriftung>Wann war die letzte Prüfung der E-Rechnungsprozesse?</Beschriftung>
            <Controller
              name="erechnungen.letzte_pruefung"
              control={control}
              render={({ field }) => (
                <TextField 
                  {...field} 
                  label="Letzte Prüfung" 
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              )}
            />
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
} 